<template>
    <div>
        <el-upload class="upload-demo" name="file" :headers="headers" :action="uploadImagePath" accept=".jpg,.png"
            :before-upload="beforeAvatarUpload" :on-success="handleSuccess" multiple />
        <div class="editor-header">
            <el-button size="mini" :type="sourceMode ? 'primary' : ''" @click="toggleSourceMode">
                {{ sourceMode ? '可视化编辑' : '源代码编辑' }}
            </el-button>
        </div>
        <div class="editor-container">
            <quill-editor ref="toref" v-model="content" :options="editorOption"
                :class="{ 'source-mode': sourceMode }"
                @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="init" />
            <textarea v-show="sourceMode" ref="sourceEditor" v-model="sourceContent" class="source-textarea"
                :disabled="disabled" placeholder="请输入HTML源代码..." @input="onSourceInput" />
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import router from '../router';

// import Quill, { Parchment } from 'quill'
import Quill from 'quill'

import { ImageDrop } from 'quill-image-drop-module'  // 图片拖动插件
import ImageResize from 'quill-image-resize-module'  // 图片设置大小插件

import { getUploadImagePath } from '../utils/util'

//Quill.register('modules/imageDrop', ImageDrop)       // 图片拖动插件
//Quill.register('modules/imageResize', ImageResize)   // 图片设置大小插件
// 鼠标移入显示title文字
import { addQuillTitle } from '@/assets/quill-title.js'
Vue.use(quillEditor)
// 图片上传接口
// import { richTextImgUpload, richTextVideoUpload } from '@/api/uploadFIle'
// let Parchment = Quill.import('parchment')
// class lineHeightAttributor extends Parchment.Attributor.Style { }
// const lineHeightStyle = new lineHeightAttributor("lineheight", "ql-lineheight", {
//     scope: Parchment.Scope.INLINE,
//     whitelist: ["", "1", "1-5", "1-75", "2", "3", "4", "5"]
// });
// console.log('lineHeightStyle===>', lineHeightStyle)

// // class lineHeightAttributor extends Parchment.ClassAttributor { }
// // const lineHeightStyle = new lineHeightAttributor("lineheight", "ql-lineheight", {
// //     scope: Parchment.Scope.INLINE,
// //     whitelist: ["", "1", "1-5", "1-75", "2", "3", "4", "5"]
// // });



// Quill.register({ 'formats/lineHeight': lineHeightStyle }, true);
const fonts = ['serif', 'sans-serif', 'monospace', 'YourCustomFont']; // 添加你的自定义字体

const Font = Quill.import('formats/font');
Font.whitelist = fonts;
Quill.register(Font, true);
// Quill Snow 主题默认色板 (8列 x 5行)
const quillDefaultColors = [
  "#000000", "#FF0000", "#FF9900", "#FFFF00", "#008000", "#0066FF", "#9900FF",
  "#FFFFFF","#FFCCCC", "#FFE5CC", "#FFFFCC", "#CCE5CC", "#CCE5FF", "#E5CCFF",
  "#BFBFBF", "#FF8080", "#FFCC80", "#FFFF80", "#80CC80", "#80BFFF", "#CC80FF",
  "#999999", "#CC0000", "#CC6600", "#CCCC00", "#006600", "#0033CC", "#6600CC",
  "#666666", "#990000", "#804000", "#808000", "#004400", "#002266", "#440099"
]
const fastemsColors = ['#F03212', '#7BDFF2', '#19535F', '#484E53', '#F0F0F0']
const combinedColors = [...quillDefaultColors, ...fastemsColors]

// 字号可选项 -- 设置字体大小
const fontSizeStyle = Quill.import('attributors/style/size') // 引入这个后会把样式写在style上
fontSizeStyle.whitelist = [false, 'x-small', 'large', 'xx-large', '12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px', '48px']
Quill.register(fontSizeStyle, true)

// 字间距可选项
const letterSpacingWhitelist = ['default', '0px', '1px', '2px', '3px', '4px', '5px', '6px', '8px', '10px']

// 工具栏配置
const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
    ['blockquote', 'code-block'], // 引用，代码块

    [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
    [{ list: 'ordered' }, { list: 'bullet' }], // 列表
    [{ script: 'sub' }, { script: 'super' }], // 上下标
    [{ indent: '-1' }, { indent: '+1' }], // 缩进
    [{ direction: 'rtl' }], // 文本方向

    // [{ size: ['small', false, 'large', 'xx-large'] }], // 字体大小
     [{ size: fontSizeStyle.whitelist }], // 字体大小----
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题

    [{ color: combinedColors }, { background: combinedColors }],
    // [{ font: [] }], // 字体
    [{ align: [] }], // 对齐方式
    // [{ lineheight: ['initial', '1', '1.5', '1.75', '2', '3', '4', '5'] }], // 对齐方式
    // [{ lineheight: ["default", "1", "1.5", "1.6", "1.7", "1.75", "1.8", "1.9", "2", "3", "4"] }], // 对齐方式
    [{ lineheight: ["default", "1", "1.5", "1.6", "1.7", "1.8", "1.9", "2", "3", "4"] }], // 对齐方式
    [{ letterspacing: letterSpacingWhitelist }], // 字间距
    [{ font: fonts }],
    // [{ lineHeight: lineHeight }],
    ['clean'], // 清除字体样式
    ['image']//, 'video'] // 上传图片、上传视频
]



/* 富文本编辑图片上传配置*/
const uploadConfig = {
    action: '', // 必填参数 图片上传地址
    methods: 'POST', // 必填参数 图片上传方式
    token: '', // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
    name: 'img', // 必填参数 文件的参数名
    size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
    accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon' // 可选 可上传的图片格式
}
export default {
    components: {
        quillEditor
    },
    computed: {
        headers() {
            return {
                // 'Content-Type': 'multipart/form-data',
                'Authorization': localStorage.getItem('refreshToken')
            }
        }
    },
    props: {
        contents: {
            type: String,
            default: ''
        },
        default: '',
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            content: '',
            lastSelection: null,
            sourceMode: false,
            sourceContent: '',
            videoOrimg: true,
            uploadImagePath: '',
            editorOption: {
                placeholder: '请输入...',
                modules: {
                    //ImageResize: {}, //图片拖动设置大小
                    //ImageDrop: true, // 图片拖动
                    toolbar: {
                        container: toolbarOptions, //工具栏
                        handlers: {
                            image: (value) => {
                                if (value) {
                                    // 这是是为了获取你当前点击的那个富文本框
                                    this.videoOrimg = true
                                    document.querySelectorAll('.upload-demo input')[0].click()
                                } else {
                                    this.quill.format('image', false)
                                }
                            },
                            video: (value) => {
                                if (value) {
                                    // 这是是为了获取你当前点击的那个富文本框
                                    this.videoOrimg = false
                                    document.querySelectorAll('.upload-demo input')[0].click()
                                } else {
                                    this.quill.format('image', false)
                                }
                            },
                            lineheight: function (value) {
                                if (value) {
                                    this.quill.format('lineHeight', value);
                                } else {
                                    console.log(value);
                                }
                            },
                            letterspacing: function (value) {
                                if (value && value !== 'default') {
                                    this.quill.format('letterSpacing', value);
                                } else {
                                    this.quill.format('letterSpacing', false);
                                }
                            },

                        }
                    }
                },
                theme: 'snow'
            }
        }
    },
    mounted() {
        addQuillTitle()
        this.uploadImagePath = getUploadImagePath()
        this.$nextTick(() => {
            const quill = this.$refs.toref.quill
            quill.on('selection-change', (range) => {
                if (range) {
                    this.lastSelection = range
                }
            })
            this.addColorInput('color')
            this.addColorInput('background')
        })
    },

    methods: {
        addColorInput(type) {
            const pickerClass = type === 'color' ? '.ql-color' : '.ql-background'
            const picker = this.$el.querySelector(pickerClass)
            if (!picker) return
            const options = picker.querySelector('.ql-picker-options')
            if (!options || options.querySelector('.ql-custom-color-input')) return

            const quill = this.$refs.toref.quill

            const applyColor = () => {
                const value = input.value.trim()
                if (!value) return
                const range = this.lastSelection
                if (range) {
                    quill.formatText(range.index, range.length, type, value)
                }
                picker.classList.remove('ql-picker-open')
            }

            const wrapper = document.createElement('div')
            wrapper.className = 'ql-custom-color-wrapper'

            const input = document.createElement('input')
            input.className = 'ql-custom-color-input'
            input.placeholder = type === 'color' ? '输入颜色, 如 #FF0000' : '输入背景色, 如 #FF0000'
            input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault()
                    e.stopPropagation()
                    applyColor()
                }
            })

            const btn = document.createElement('button')
            btn.className = 'ql-custom-color-btn'
            btn.textContent = '确定'
            btn.addEventListener('click', (e) => {
                e.preventDefault()
                e.stopPropagation()
                applyColor()
            })

            wrapper.appendChild(input)
            wrapper.appendChild(btn)
            options.appendChild(wrapper)
        },
        toggleSourceMode() {
            if (!this.sourceMode) {
                this.sourceContent = this.content
                this.sourceMode = true;
            } else {
                this.content = this.sourceContent
                this.sourceMode = false
                this.$nextTick(() => {
                    if (this.$refs.toref && this.$refs.toref.quill) {
                        this.$refs.toref.quill.root.innerHTML = this.sourceContent;
                    }
                })
            }
        },
        onSourceInput(val) {
            this.content = val
        },
        // 覆盖默认的上传行为
        requestUpload(params) {
            const formData = new FormData()
            formData.append('img', params.file)
            // 图片
            if (this.videoOrimg) {
                // richTextImgUpload(formData).then((res) => {
                //     params.onSuccess(res)
                // })
            } else {
                // richTextVideoUpload(formData).then((res) => {
                //     params.onSuccess(res)
                // })
            }

        },
        // 判断图片后缀
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || 'image/png'
            const isVideo = file.type === 'video/mp4'
            const isLt2M = file.size / 1024 / 1024 < 10
            // 图片
            if (this.videoOrimg) {
                if (!isJPG) {
                    this.$message.error('上传图片只能是 JPG , PNG格式!')
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 10MB!')
                }
                return isJPG && isLt2M
            } else {
                if (!isVideo) {
                    this.$message.error('上传视频只能是 MP4格式!')
                }
                return isVideo
            }
        },
        // 上传成功
        handleSuccess(res, file) {
            if (res.code == 200) {
                // 动态添加 ref  通过 eval () 去执行
                const toeval = this.$refs.toref.quill
                // eval() 函数可计算某个字符串，并执行其中的的 JavaScript 代码。
                // 获取光标所在位置
                const length = toeval.selection.savedRange.index
                // 插入图片，res为服务器返回的图片链接地址
                // 图片
                if (this.videoOrimg) {
                    toeval.insertEmbed(
                        length,
                        'image',
                        res.data
                    )
                } else {
                    toeval.insertEmbed(
                        length,
                        'video',
                        res.data
                    )
                }
                // 调整光标到最后
                toeval.setSelection(length + 1)
            } else {
                this.$message({ type: 'error', message: res.message });
                //定时2秒
                setTimeout(() => {
                    router.push({ path: '/login' })
                }, 1000);
            }
        },
        // 将内容上传给父组件
        postContent() {

            this.$emit('getContent', this.content)
        },

        onEditorBlur(v) {
            v.enable(!this.disabled)
        }, // 失去焦点事件
        onEditorFocus(v) {
            v.enable(!this.disabled)
        }, // 获得焦点事件
        init() {
            const Parchment = Quill.import("parchment");
            class lineHeightAttributor extends Parchment.Attributor.Style { }

            const lineHeightStyle = new lineHeightAttributor(
                "lineHeight",
                "line-height",
                {
                    scope: Parchment.Scope.INLINE,
                    whitelist: ['1', '1.5', '1.6', '1.7', '1.8', '1.9', '2', '3', '4']
                    // whitelist: ['1', '1.5', '1.6', '1.7', '1.75', '1.8', '1.9', '2', '3', '4']
                }
            );

            class letterSpacingAttributor extends Parchment.Attributor.Style {}

            const letterSpacingStyle = new letterSpacingAttributor(
                "letterSpacing",
                "letter-spacing",
                {
                    scope: Parchment.Scope.INLINE,
                    whitelist: letterSpacingWhitelist
                }
            );

            setTimeout(() => {
                Quill.register({ "formats/lineHeight": lineHeightStyle }, true);
                Quill.register({ "formats/letterSpacing": letterSpacingStyle }, true);
            }, 1000);
        },
    },
    watch: {
        content: {
            immediate: true,    // 这句重要
            handler(val) {
                this.postContent()
            }
        },
        editorContent: {
            immediate: true,    // 这句重要
            handler(val) {
                this.content = this.contents
            }
        }
    }
}
</script>

<style scoped>
.upload-demo {
    display: none;
}

.quill-editor ::v-deep .ql-picker-options .ql-custom-color-wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    width: 100%;
    flex-basis: 100%;
    margin-top: 6px;
    padding: 0 2px;
    box-sizing: border-box;
}

.quill-editor ::v-deep .ql-picker-options .ql-custom-color-input {
    width: 100%;
    padding: 3px 6px;
    font-size: 12px;
    line-height: 1.4;
    border: 1px solid #ccc;
    border-radius: 3px;
    outline: none;
    box-sizing: border-box;
    color: #333;
}

.quill-editor ::v-deep .ql-picker-options .ql-custom-color-input:focus {
    border-color: #409eff;
}

.quill-editor ::v-deep .ql-picker-options .ql-custom-color-input::placeholder {
    color: #999;
}

.quill-editor ::v-deep .ql-picker-options .ql-custom-color-btn {
    padding: 3px 8px;
    font-size: 12px;
    line-height: 1.4;
    border: 1px solid #409eff;
    border-radius: 3px;
    background-color: #409eff;
    color: #fff;
    cursor: pointer;
    white-space: nowrap;
    outline: none;
    width:100%;
}

.quill-editor ::v-deep .ql-picker-options .ql-custom-color-btn:hover {
    background-color: #66b1ff;
    border-color: #66b1ff;
}

.editor-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 4px;
}

.editor-container {
    /* height: 382px; */
}

.editor-container .quill-editor ::v-deep .ql-container {
    height:292px;
}
.editor-container .quill-editor {
    /* height: 100%; */
    display: flex;
    flex-direction: column;
}

.editor-container .quill-editor.source-mode ::v-deep .ql-container {
    display: none;
}

.editor-container .quill-editor.source-mode ::v-deep .ql-toolbar {
    pointer-events: none;
    opacity: 0.5;
}

.source-textarea {
    width: 100%;
    height: 292px;
    padding: 12px 15px;
    border: 1px solid #ccc;
    border-radius: 0 0 3px 3px;
    font-family: Consolas, 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.5;
    color: #333;
    resize: none;
    outline: none;
    box-sizing: border-box;
    border-top: none;
}

.source-textarea:focus {
    border-color: #ccc;
}

.source-textarea:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
}


.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '正常';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='x-small']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='x-small']::before {
    content: '小';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
    content: '大';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='xx-large']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='xx-large']::before {
    content: '超大';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='12px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='12px']::before {
    content: '12px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='14px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='14px']::before {
    content: '14px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='16px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='16px']::before {
    content: '16px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='18px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {
    content: '18px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='20px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='20px']::before {
    content: '20px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='24px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='24px']::before {
    content: '24px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='28px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='28px']::before {
    content: '28px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='32px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='32px']::before {
    content: '32px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='36px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='36px']::before {
    content: '36px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='48px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='48px']::before {
    content: '48px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='default']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='default']::before {
    content: '字间距';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='0px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='0px']::before {
    content: '0px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='1px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='1px']::before {
    content: '1px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='2px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='2px']::before {
    content: '2px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='3px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='3px']::before {
    content: '3px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='4px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='4px']::before {
    content: '4px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='5px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='5px']::before {
    content: '5px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='6px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='6px']::before {
    content: '6px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='8px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='8px']::before {
    content: '8px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-label[data-value='10px']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing .ql-picker-item[data-value='10px']::before {
    content: '10px';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-letterspacing {
    width: 90px;
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='default']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='default']::before {
    content: '行高';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='1']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1']::before {
    content: '1';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='1.5']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.5']::before {
    content: '1.5';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='1.6']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.6']::before {
    content: '1.6';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='1.7']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.7']::before {
    content: '1.7';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='1.75']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.75']::before {
    content: '1.75';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='1.8']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.8']::before {
    content: '1.8';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='1.9']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.9']::before {
    content: '1.9';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='2']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='2']::before {
    content: '2';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='3']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='3']::before {
    content: '3';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='4']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='4']::before {
    content: '4';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value='5']::before,
.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='5']::before {
    content: '5';
}

.quill-editor ::v-deep .ql-snow .ql-picker.ql-lineheight {
    width: 70px;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-1 {
    line-height: 1;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-1-5 {
    line-height: 1.5;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-1-6 {
    line-height: 1.6;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-1-7 {
    line-height: 1.7;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-1-75 {
    line-height: 1.75;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-1-8 {
    line-height: 1.8;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-1-9 {
    line-height: 1.9;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-2 {
    line-height: 2;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-3 {
    line-height: 3;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-4 {
    line-height: 4;
}

.quill-editor ::v-deep .ql-snow .ql-editor .ql-lineheight-5 {
    line-height: 5;
}
</style>